// removed by extract-text-webpack-plugin
module.exports = {"blogPostRows":"_2RvlG7hIQdRoP0OREuddKh","blogPostRow":"_2vzt0VK6JE8j9s0KjlpuuH","instagramsLabel":"_3l3Pz18MAEdHGqYMB4dZG3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/blog/Blog.css
// module id = 526
// module chunks = 0